import { useEffect, useRef } from 'react';

import { Accordion } from '@klv/utils/accordion';

import Icon from '../icon';
import * as s from './styles/filter-accordion.module.css';
import type { IFilterAccordion } from './types';

const FilterAccordion = ({
  children,
  className = '',
  label = '',
}: IFilterAccordion) => {
  const ref = useRef<HTMLDetailsElement>(null);

  useEffect(() => {
    if (ref.current) {
      new Accordion(ref.current);
    }
  }, [ref]);
  return (
    <div className={className}>
      <details open ref={ref}>
        <summary className={s.headerContainer}>
          {label}
          <div className={s.chevron}>
            <Icon iconName='ChevronNorth' size={2} fillColor='currentColor' />
          </div>
        </summary>
        <div className={`${s.content} content`}>
          {children}
        </div>
      </details>
    </div>
  );
};

export default FilterAccordion;
